import clsx from 'clsx';
import { cloneElement, h } from 'preact';

export const icons = {
  search: (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.25 14.25C11.5637 14.25 14.25 11.5637 14.25 8.25C14.25 4.93629 11.5637 2.25 8.25 2.25C4.93629 2.25 2.25 4.93629 2.25 8.25C2.25 11.5637 4.93629 14.25 8.25 14.25Z"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M15.7498 15.75L12.4873 12.4875"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  ),
  link: (
    <svg
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.7527 8.27593L14.2761 10.7525C13.9843 11.0444 13.509 11.0376 13.2256 10.7375C12.97 10.4676 12.9755 10.0432 13.2384 9.78041L15.7473 7.27162C16.2836 6.7348 16.5792 6.02117 16.5792 5.26203C16.5792 4.50289 16.2836 3.78926 15.7473 3.25244C14.6394 2.1444 12.8363 2.1444 11.7282 3.25244L9.2493 5.73175C8.96742 6.01367 8.51398 6.02631 8.23208 5.74441C7.95028 5.46244 7.9628 5.00902 8.24467 4.72712L10.7236 2.24781C12.3857 0.585367 15.0905 0.585367 16.7524 2.24781C17.5572 3.05229 18.0006 4.12338 18.0006 5.26187C18.0006 6.40035 17.5574 7.47063 16.7527 8.27593Z"
        fill="currentColor"
      />
      <path
        d="M5.71949 8.21025C5.45093 7.94169 5.01932 7.95206 4.75072 8.22059L2.2479 10.7228C1.44325 11.5281 1 12.5983 1 13.7368C1 14.8753 1.44341 15.9464 2.24822 16.7509C3.07905 17.5822 4.17073 17.9977 5.26228 17.9977C6.354 17.9977 7.44551 17.5821 8.27634 16.7509L10.7865 14.2403C11.0478 13.979 11.0503 13.5565 10.7891 13.2951C10.4937 12.9997 10.0152 13.0023 9.71979 13.2978L7.27171 15.7463C6.16367 16.8543 4.36056 16.8543 3.25269 15.7463C2.71635 15.2094 2.42076 14.4958 2.42076 13.7367C2.42076 12.9775 2.71636 12.2639 3.25269 11.7271L5.70916 9.27098C6.00272 8.97746 6.01294 8.50388 5.71949 8.21025Z"
        fill="currentColor"
      />
      <path
        d="M13.0521 6.95157L6.95226 13.0514C6.67485 13.3288 6.22507 13.3288 5.94771 13.0513C5.67026 12.774 5.67022 12.3242 5.94763 12.0468L12.0475 5.94694C12.3212 5.67317 12.7684 5.68315 13.0421 5.95692C13.3158 6.23074 13.3258 6.67784 13.0521 6.95157Z"
        fill="currentColor"
      />
    </svg>
  ),
  threekitLogo: (
    <svg
      width="22"
      height="24"
      viewBox="0 0 22 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1806_87937)">
        <path
          d="M20.4801 5.17262L10.2405 0.142645C10.0516 0.0498033 9.84317 0.00175484 9.63197 0.00235541C9.42076 0.00295599 9.21264 0.0521888 9.02431 0.146103V0.135296L6.24219 1.50215L6.25143 1.50734C6.44188 1.40818 6.65371 1.35518 6.86924 1.35277C7.08477 1.35037 7.29777 1.39862 7.49047 1.49351L17.7323 6.52348C18.1892 6.74778 18.5734 7.09267 18.8419 7.51948C19.1104 7.94629 19.2526 8.43815 19.2525 8.93991V19.9478C19.2526 20.2023 19.1785 20.4514 19.0391 20.6659C18.8997 20.8804 18.7008 21.0512 18.4658 21.1582V21.169L21.2497 19.8017L21.2405 19.7961C21.4686 19.6861 21.6608 19.5154 21.7951 19.3034C21.9295 19.0914 22.0006 18.8467 22.0003 18.597V7.58904C22.0004 7.08729 21.8582 6.59543 21.5897 6.16861C21.3212 5.7418 20.937 5.39691 20.4801 5.17262Z"
          fill="currentColor"
        />
        <path
          d="M14.9798 7.87434L4.74012 2.84437C4.55124 2.75152 4.34283 2.70348 4.13162 2.70408C3.92042 2.70468 3.7123 2.75391 3.52396 2.84782V2.83702L0.741841 4.20388L0.751081 4.20906C0.525226 4.31984 0.335288 4.4903 0.202609 4.70129C0.0699301 4.91228 -0.000233858 5.15544 5.85604e-07 5.40344V16.4114C-3.25662e-05 16.9131 0.142174 17.405 0.410681 17.8318C0.679187 18.2586 1.06338 18.6035 1.5202 18.8278L11.7599 23.8578C11.9468 23.9493 12.1528 23.997 12.3616 23.997C12.5704 23.997 12.7764 23.9493 12.9633 23.8578V23.8686L15.7472 22.5013L15.7379 22.4957C15.9662 22.3861 16.1586 22.2159 16.2933 22.0043C16.428 21.7927 16.4996 21.5483 16.5 21.2987V10.2908C16.5001 9.78901 16.3579 9.29715 16.0894 8.87034C15.8209 8.44352 15.4367 8.09863 14.9798 7.87434ZM13.75 11.6416V16.7291L9.7702 14.7752C9.31338 14.5509 8.92919 14.206 8.66068 13.7792C8.39217 13.3524 8.24997 12.8605 8.25 12.3588V7.27001L12.232 9.2252C12.6884 9.4498 13.0722 9.79482 13.3403 10.2216C13.6084 10.6484 13.7503 11.1401 13.75 11.6416ZM1.44628 4.06339C1.41108 4.06339 1.37544 4.05561 1.34068 4.05647C1.37544 4.05517 1.41108 4.06339 1.44628 4.06339ZM1.05248 4.09754C1.04808 4.09754 1.0428 4.09754 1.0384 4.10013C1.0428 4.09927 1.04808 4.09883 1.05248 4.09754ZM13.2695 23.6637C13.2731 23.6613 13.2765 23.6587 13.2796 23.6559L13.2695 23.6637ZM13.501 23.4117C13.5106 23.3978 13.5225 23.3857 13.5318 23.3715C13.5225 23.3862 13.5106 23.3978 13.501 23.4117ZM13.6611 23.1043C13.6704 23.0788 13.6849 23.0568 13.6924 23.0304C13.684 23.0568 13.6708 23.0788 13.6611 23.1043ZM4.2702 17.4769C3.81338 17.2526 3.42919 16.9077 3.16068 16.4809C2.89217 16.0541 2.74997 15.5622 2.75 15.0605V4.56829L1.99012 4.19523C1.8854 4.1442 1.77452 4.10643 1.66012 4.08284C1.77461 4.1061 1.88554 4.14389 1.99012 4.19523L5.5 5.91915V13.7096C5.49997 14.2114 5.64217 14.7032 5.91068 15.13C6.17919 15.5568 6.56338 15.9017 7.0202 16.1261L13.7522 19.4321V22.1326L4.2702 17.4769Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_1806_87937">
          <rect width="22" height="24" fill="currentColor" />
        </clipPath>
      </defs>
    </svg>
  ),
  polygon: (
    <svg
      width="15"
      height="9"
      viewBox="0 0 15 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.9"
        d="M7.5 0L14.8612 8.25H0.138784L7.5 0Z"
        fill="currentColor"
      />
    </svg>
  ),
  fullScreen: (
    <svg
      width="23"
      height="17"
      viewBox="0 0 23 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.7588 1.36017H21.9988V7.24017"
        stroke="currentColor"
        strokeWidth="2"
      />
      <path
        d="M10.2412 15.6403L1.00121 15.6403L1.00121 9.76029"
        stroke="currentColor"
        strokeWidth="2"
      />
      <path
        d="M12.7588 15.6403L21.9988 15.6403L21.9988 9.76029"
        stroke="currentColor"
        strokeWidth="2"
      />
      <path
        d="M10.2412 1.36017L1.00121 1.36017L1.00121 7.24017"
        stroke="currentColor"
        strokeWidth="2"
      />
    </svg>
  ),
  heart: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.7307 7.23475C18.3297 6.84337 17.8531 6.53284 17.3284 6.32096C16.8038 6.10907 16.2412 6 15.6731 6C15.105 6 14.5424 6.10907 14.0177 6.32096C13.4931 6.53284 13.0165 6.84337 12.6155 7.23475L12 7.84113L11.3845 7.23475C10.9835 6.84337 10.5069 6.53284 9.98225 6.32096C9.45756 6.10907 8.89503 6 8.3269 6C7.75878 6 7.19624 6.10907 6.67155 6.32096C6.14686 6.53284 5.67034 6.84337 5.26932 7.23475C3.57466 8.88288 3.47074 11.666 5.60505 13.7806L12 20L18.3949 13.7806C20.5293 11.666 20.4253 8.88288 18.7307 7.23475Z"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  share: (
    <svg
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.16699 9.5V15.8333C3.16699 16.2533 3.33381 16.656 3.63074 16.9529C3.92767 17.2499 4.3304 17.4167 4.75033 17.4167H14.2503C14.6703 17.4167 15.073 17.2499 15.3699 16.9529C15.6668 16.656 15.8337 16.2533 15.8337 15.8333V9.5"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.6663 4.75001L9.49967 1.58334L6.33301 4.75001"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.5 1.58334V11.875"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  upload: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21 15V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V15"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17 8L12 3L7 8"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 3V15"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  successCheck: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="24" height="24" rx="4" fill="#2EA633" />
      <path
        d="M6 12L10.28 16.3895L17.9961 7.7915"
        stroke="white"
        strokeWidth="2"
      />
    </svg>
  ),
  warningExclamation: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="24" height="24" rx="4" fill="#FF9900" />
      <path
        d="M10.92 14.192H12.264L13.016 7.12V6.8H10.168V7.12L10.92 14.192ZM10.296 18H12.888V15.44H10.296V18Z"
        fill="white"
      />
    </svg>
  ),
  errorX: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="24" height="24" rx="4" fill="#DC1515" />
      <path
        d="M16.25 15.9992L7.75043 7.49964"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M7.75 15.9992L16.2496 7.49964"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  ),
  exitIcon: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M4 20L20 4" stroke="#FF5200" strokeWidth="1.5" />
      <path d="M4 4L20 20" stroke="#FF5200" strokeWidth="1.5" />
    </svg>
  ),
  inspo: (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.773438"
        y="4.11247"
        width="12.8431"
        height="12.8431"
        rx="1.5"
        stroke="currentColor"
      />
      <path
        d="M3.15552 3.90089V2.72852C3.15552 1.62395 4.05095 0.728516 5.15552 0.728516H14.9986C16.1032 0.728516 16.9986 1.62395 16.9986 2.72852V12.5716C16.9986 13.6762 16.1032 14.5716 14.9986 14.5716H13.8262"
        stroke="currentColor"
      />
      <path
        d="M0.992065 5.2527L7.77198 14.1946L9.39685 12.6368L13.4345 15.8091"
        stroke="currentColor"
      />
      <circle cx="10.6565" cy="7.07344" r="1.15359" fill="currentColor" />
    </svg>
  ),
  shuffleIconDesktop: (
    <svg
      width="161"
      height="36"
      viewBox="0 0 161 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.5">
        <path
          d="M23.7715 1H46.4381V34.9999H23.7715V1Z"
          fill="black"
          fillOpacity="0.3"
        />
        <path
          d="M0.787109 2.50227C0.787109 1.67259 1.4597 1 2.28938 1H23.4537V34.9999H2.28938C1.4597 34.9999 0.787109 34.3274 0.787109 33.4977V2.50227Z"
          fill="black"
          fillOpacity="0.3"
        />
        <path
          d="M160.828 33.4977C160.828 34.3274 160.156 35 159.326 35L138.161 35L138.161 1.00005L159.326 1.00005C160.156 1.00005 160.828 1.67264 160.828 2.50232L160.828 33.4977Z"
          fill="black"
          fillOpacity="0.3"
        />
        <path
          d="M46.7559 1H69.4225V34.9999H46.7559V1Z"
          fill="black"
          fillOpacity="0.3"
        />
        <path
          d="M69.7422 1H92.4088V34.9999H69.7422V1Z"
          fill="black"
          fillOpacity="0.3"
        />
        <path
          d="M92.7266 1H115.393V34.9999H92.7266V1Z"
          fill="black"
          fillOpacity="0.3"
        />
        <path
          d="M115.711 1H138.378V34.9999H115.711V1Z"
          fill="black"
          fillOpacity="0.3"
        />
      </g>
      <mask
        id="mask0_1837_82121"
        style="mask-type:alpha"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="161"
        height="36"
      >
        <path d="M23.7715 1H46.4381V34.9999H23.7715V1Z" fill="black" />
        <path
          d="M23.6901 1V0.763625H23.4537H2.28938C1.32915 0.763625 0.550735 1.54204 0.550735 2.50227V33.4977C0.550735 34.4579 1.32915 35.2363 2.28938 35.2363H23.4537H23.6901V34.9999V1Z"
          fill="black"
          stroke="currentColor"
          strokeWidth="0.472749"
        />
        <path
          d="M160.828 33.4977C160.828 34.3274 160.156 35 159.326 35L138.161 35L138.161 1.00005L159.326 1.00005C160.156 1.00005 160.828 1.67264 160.828 2.50232L160.828 33.4977Z"
          fill="black"
        />
        <path d="M46.7559 1H69.4225V34.9999H46.7559V1Z" fill="black" />
        <path d="M69.7422 1H92.4088V34.9999H69.7422V1Z" fill="black" />
        <path d="M92.7266 1H115.393V34.9999H92.7266V1Z" fill="black" />
        <path d="M115.711 1H138.378V34.9999H115.711V1Z" fill="black" />
      </mask>
      <g mask="url(#mask0_1837_82121)">
        <path
          d="M11.513 42.5049C13.8064 42.5049 15.4132 41.288 15.4132 39.2443V39.2131C15.4132 37.4034 14.2276 36.5766 11.9187 36.015C9.81257 35.5158 9.31334 35.1413 9.31334 34.2989V34.2677C9.31334 33.5501 9.96857 32.9728 11.0918 32.9728C12.0903 32.9728 13.0731 33.3629 14.056 34.0961L15.0856 32.6452C13.978 31.756 12.7143 31.2724 11.123 31.2724C8.95453 31.2724 7.39445 32.5672 7.39445 34.4393V34.4705C7.39445 36.483 8.70492 37.1694 11.0294 37.7311C13.0575 38.1991 13.4943 38.6203 13.4943 39.4003V39.4315C13.4943 40.2428 12.7455 40.8044 11.5598 40.8044C10.2182 40.8044 9.15734 40.2896 8.11209 39.3847L6.95763 40.7576C8.26809 41.9277 9.84377 42.5049 11.513 42.5049Z"
          fill="currentColor"
        />
        <path
          d="M11.513 22.9253C13.8064 22.9253 15.4132 21.7084 15.4132 19.6647V19.6335C15.4132 17.8239 14.2276 16.997 11.9187 16.4354C9.81257 15.9362 9.31334 15.5618 9.31334 14.7193V14.6881C9.31334 13.9705 9.96857 13.3933 11.0918 13.3933C12.0903 13.3933 13.0731 13.7833 14.056 14.5165L15.0856 13.0656C13.978 12.1764 12.7143 11.6928 11.123 11.6928C8.95453 11.6928 7.39445 12.9876 7.39445 14.8597V14.8909C7.39445 16.9034 8.70492 17.5898 11.0294 18.1515C13.0575 18.6195 13.4943 19.0407 13.4943 19.8208V19.852C13.4943 20.6632 12.7455 21.2248 11.5598 21.2248C10.2182 21.2248 9.15734 20.71 8.11209 19.8051L6.95763 21.178C8.26809 22.3481 9.84377 22.9253 11.513 22.9253Z"
          fill="currentColor"
        />
        <path
          d="M11.513 3.34572C13.8064 3.34572 15.4132 2.12886 15.4132 0.0851682V0.0539669C15.4132 -1.75572 14.2276 -2.58256 11.9187 -3.14418C9.81257 -3.64341 9.31334 -4.01782 9.31334 -4.86026V-4.89146C9.31334 -5.6091 9.96857 -6.18632 11.0918 -6.18632C12.0903 -6.18632 13.0731 -5.79631 14.056 -5.06307L15.0856 -6.51394C13.978 -7.40318 12.7143 -7.8868 11.123 -7.8868C8.95453 -7.8868 7.39445 -6.59194 7.39445 -4.71986V-4.68865C7.39445 -2.67616 8.70492 -1.98973 11.0294 -1.4281C13.0575 -0.96008 13.4943 -0.538861 13.4943 0.241175V0.272377C13.4943 1.08361 12.7455 1.64524 11.5598 1.64524C10.2182 1.64524 9.15734 1.13042 8.11209 0.225575L6.95763 1.59844C8.26809 2.76849 9.84377 3.34572 11.513 3.34572Z"
          fill="currentColor"
        />
        <path
          d="M29.7173 42.3489H31.6362V37.7467H36.8469V42.3489H38.7657V31.4284H36.8469V35.9682H31.6362V31.4284H29.7173V42.3489Z"
          fill="currentColor"
        />
        <path
          d="M29.7173 22.7693H31.6362V18.1671H36.8469V22.7693H38.7657V11.8488H36.8469V16.3886H31.6362V11.8488H29.7173V22.7693Z"
          fill="currentColor"
        />
        <path
          d="M29.7173 3.18971H31.6362V-1.4125H36.8469V3.18971H38.7657V-7.7308H36.8469V-3.19098H31.6362V-7.7308H29.7173V3.18971Z"
          fill="currentColor"
        />
        <path
          d="M58.0319 42.5205C60.8868 42.5205 62.7277 40.8824 62.7277 37.6219V31.4284H60.8088V37.7155C60.8088 39.728 59.7636 40.742 58.0631 40.742C56.347 40.742 55.3018 39.6656 55.3018 37.6375V31.4284H53.3829V37.7155C53.3829 40.8824 55.1926 42.5205 58.0319 42.5205Z"
          fill="currentColor"
        />
        <path
          d="M58.0319 22.9409C60.8868 22.9409 62.7277 21.3028 62.7277 18.0423V11.8488H60.8088V18.1359C60.8088 20.1484 59.7636 21.1624 58.0631 21.1624C56.347 21.1624 55.3018 20.086 55.3018 18.0579V11.8488H53.3829V18.1359C53.3829 21.3028 55.1926 22.9409 58.0319 22.9409Z"
          fill="currentColor"
        />
        <path
          d="M58.0319 3.36132C60.8868 3.36132 62.7277 1.72324 62.7277 -1.53731V-7.7308H60.8088V-1.4437C60.8088 0.568791 59.7636 1.58284 58.0631 1.58284C56.347 1.58284 55.3018 0.506388 55.3018 -1.52171V-7.7308H53.3829V-1.4437C53.3829 1.72324 55.1926 3.36132 58.0319 3.36132Z"
          fill="currentColor"
        />
        <path
          d="M77.87 42.3489H79.7889V37.9027H85.2959V36.1554H79.7889V33.1757H85.9979V31.4284H77.87V42.3489Z"
          fill="currentColor"
        />
        <path
          d="M77.87 22.7693H79.7889V18.3231H85.2959V16.5758H79.7889V13.5961H85.9979V11.8488H77.87V22.7693Z"
          fill="currentColor"
        />
        <path
          d="M77.87 3.18971H79.7889V-1.25649H85.2959V-3.00378H79.7889V-5.98351H85.9979V-7.7308H77.87V3.18971Z"
          fill="currentColor"
        />
        <path
          d="M100.554 42.3489H102.472V37.9027H107.98V36.1554H102.472V33.1757H108.682V31.4284H100.554V42.3489Z"
          fill="currentColor"
        />
        <path
          d="M100.554 22.7693H102.472V18.3231H107.98V16.5758H102.472V13.5961H108.682V11.8488H100.554V22.7693Z"
          fill="currentColor"
        />
        <path
          d="M100.554 3.18971H102.472V-1.25649H107.98V-3.00378H102.472V-5.98351H108.682V-7.7308H100.554V3.18971Z"
          fill="currentColor"
        />
        <path
          d="M123.249 42.3489H130.909V40.6016H125.168V31.4284H123.249V42.3489Z"
          fill="currentColor"
        />
        <path
          d="M123.249 22.7693H130.909V21.022H125.168V11.8488H123.249V22.7693Z"
          fill="currentColor"
        />
        <path
          d="M123.249 3.18971H130.909V1.44243H125.168V-7.7308H123.249V3.18971Z"
          fill="currentColor"
        />
        <path
          d="M145.527 42.3489H153.702V40.6328H147.446V37.7155H152.922V35.9838H147.446V33.1444H153.624V31.4284H145.527V42.3489Z"
          fill="currentColor"
        />
        <path
          d="M145.527 22.7693H153.702V21.0532H147.446V18.1359H152.922V16.4042H147.446V13.5649H153.624V11.8488H145.527V22.7693Z"
          fill="currentColor"
        />
        <path
          d="M145.527 3.18971H153.702V1.47363H147.446V-1.4437H152.922V-3.17538H147.446V-6.01472H153.624V-7.7308H145.527V3.18971Z"
          fill="currentColor"
        />
      </g>
      <path
        opacity="0.5"
        d="M160.828 32.072C160.828 33.7175 159.494 35.0515 157.849 35.0515L3.76581 35.0514C2.12029 35.0514 0.786331 33.7175 0.786331 32.0719C0.786332 30.4264 2.1203 29.0924 3.76584 29.0924L157.849 29.0925C159.494 29.0925 160.828 30.4264 160.828 32.072Z"
        fill="url(#paint0_linear_1837_82121)"
      />
      <path
        opacity="0.5"
        d="M0.787109 3.9795C0.787109 2.33397 2.12108 1 3.76661 1H157.849C159.495 1 160.829 2.33397 160.829 3.9795C160.829 5.62503 159.495 6.959 157.849 6.959H3.76661C2.12108 6.959 0.787109 5.62503 0.787109 3.9795Z"
        fill="url(#paint1_linear_1837_82121)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1837_82121"
          x1="80.8072"
          y1="35.0514"
          x2="80.8072"
          y2="29.0924"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopOpacity="0.51" />
          <stop offset="1" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_1837_82121"
          x1="80.808"
          y1="1"
          x2="80.808"
          y2="6.959"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopOpacity="0.51" />
          <stop offset="1" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  ),
  shuffleIconMobile: (
    <svg
      width="21"
      height="17"
      viewBox="0 0 21 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.2287 0.800049L16.1558 1.85661L17.8956 3.56978H12.14V5.06415H17.8956L16.1558 6.77732L17.2287 7.83388L20.8 4.31696L17.2287 0.800049ZM0 3.56978V5.06415H9.10491V14.0303H17.8955L16.1556 15.7435L17.2285 16.8L20.7999 13.2831L17.2285 9.76622L16.1556 10.8228L17.8955 12.536H10.6224V3.56978H0ZM0 12.536V14.0303H7.58743V12.536H0Z"
        fill="currentColor"
      />
    </svg>
  ),
  dotsMenu: (
    <svg width="23" height="5" viewBox="0 0 23 5" fill="none">
      <circle cx="2.5" cy="2.5" r="2.5" fill="currentColor" />
      <circle cx="11.5" cy="2.5" r="2.5" fill="currentColor" />
      <circle cx="20.5" cy="2.5" r="2.5" fill="currentColor" />
    </svg>
  ),
  openKnife: (
    <svg
      width="26"
      height="17"
      viewBox="0 0 26 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24.7968 14.0628C24.884 13.8221 24.9201 13.5455 24.8081 13.3179C24.7591 13.2185 24.694 13.1573 24.6002 13.099C24.5446 13.0645 24.5044 13.0533 24.4594 13.0063C24.4207 12.966 24.4152 12.9242 24.3797 12.8815C24.3609 12.8591 24.3381 12.8389 24.3105 12.8263C24.2823 12.8134 24.2315 12.8019 24.2014 12.7936C24.1077 12.7676 24.1176 12.6895 24.0529 12.6299C24.0088 12.5893 23.9239 12.5695 23.8735 12.5372C23.8313 12.51 23.8021 12.4732 23.7672 12.4381C23.7103 12.3812 23.6437 12.3337 23.5771 12.2871C23.3123 12.1016 19.2446 9.43218 17.8119 8.75091C16.3793 8.06964 13.429 6.39338 12.9274 6.18333C12.8698 6.15919 12.8072 6.1641 12.7416 6.19155C12.763 6.20114 12.7722 6.2055 12.7722 6.2055C12.7722 6.2055 11.9612 6.77918 11.302 8.71924C11.302 8.71924 11.2932 8.71347 11.2774 8.70448C11.2231 8.93184 11.1401 9.21368 11.2965 9.4053C11.4442 9.5868 11.5117 9.66882 11.6014 9.71586C11.691 9.76289 11.8656 9.73735 11.97 9.73753C12.482 9.73892 13.0164 9.82837 13.4972 9.96644C14.0034 10.1117 14.4818 10.3239 14.934 10.572C15.3839 10.8189 15.809 11.1022 16.2171 11.4039C16.3595 11.5091 16.4994 11.6172 16.6377 11.727C17.3732 12.3117 18.2134 12.7611 19.0569 13.1994C19.5167 13.4382 19.998 13.6824 20.4484 13.9352C20.8887 14.1821 21.2845 14.462 21.6682 14.7824C21.7308 14.8348 21.7918 14.889 21.8505 14.9453C21.9766 15.0663 22.0706 15.2135 22.196 15.3332C22.3482 15.4783 22.5294 15.5477 22.7312 15.6185C22.8814 15.6711 23.0682 15.7668 23.2385 15.7352C23.3581 15.713 23.459 15.6337 23.5586 15.57C23.6919 15.4848 23.8335 15.4121 23.9602 15.3171C24.1323 15.1879 24.2461 15.0367 24.3733 14.8704C24.5685 14.6153 24.6906 14.3555 24.7968 14.0628ZM24.0563 14.0544L23.6569 13.1957C23.6285 13.1346 23.6343 13.0625 23.6726 13.0024L23.6813 12.9887C23.8041 12.7954 24.1372 13.0466 24.2089 13.1043C24.2177 13.1112 24.2265 13.1179 24.2358 13.1244C24.3192 13.1833 24.7634 13.5238 24.5881 13.9718C24.3948 14.4652 24.0563 14.0544 24.0563 14.0544Z"
        fill="black"
      />
      <path
        d="M11.2298 8.62846C11.2298 8.62846 11.221 8.62271 11.2052 8.61373C11.1232 8.56727 10.8511 8.43613 10.6306 8.59386L10.3651 8.71079C10.3651 8.71079 10.2586 8.66551 10.0756 8.58662C9.20503 8.21175 6.60506 7.07795 5.53682 6.46057C4.38575 5.79536 2.82146 4.76609 1.98791 3.2079C1.88533 3.01613 1.79372 2.81613 1.71542 2.60798C1.71542 2.60798 5.18231 2.73672 8.58379 4.26273C11.5994 5.61567 12.502 6.0292 12.6678 6.10583C12.6892 6.1154 12.6984 6.11975 12.6984 6.11975C12.6984 6.11975 11.8882 6.69228 11.2298 8.62846Z"
        fill="black"
      />
    </svg>
  ),
  closedKnife: (
    <svg
      width="22"
      height="21"
      viewBox="0 0 22 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.6337 8.12535C17.5859 7.86455 17.4736 7.59836 17.2545 7.45339C17.1588 7.39012 17.0685 7.36944 16.9542 7.36635C16.8865 7.36455 16.8446 7.37547 16.7798 7.35704C16.7241 7.34119 16.6974 7.30665 16.6433 7.28708C16.6148 7.27683 16.5839 7.27076 16.5526 7.27392C16.5206 7.2771 16.4692 7.2934 16.4379 7.30169C16.3405 7.32738 16.3086 7.25239 16.2195 7.23294C16.1589 7.21967 16.0726 7.24635 16.0107 7.24385C15.9587 7.24153 15.9133 7.22392 15.8638 7.21078C15.7832 7.18965 15.6988 7.18198 15.6149 7.17513C15.2812 7.14768 10.2484 6.88702 8.61123 7.02673C6.97403 7.16644 3.45965 7.20976 2.90137 7.28411C2.83724 7.29263 2.78376 7.32979 2.73951 7.38859C2.76367 7.38598 2.77417 7.38506 2.77417 7.38506C2.77417 7.38506 2.34884 8.322 2.77353 10.4014C2.77353 10.4014 2.76267 10.4008 2.74383 10.401C2.81408 10.6327 2.88719 10.9282 3.12718 11.0178C3.35417 11.1028 3.45736 11.1409 3.56216 11.1361C3.66695 11.1312 3.80972 11.0171 3.90318 10.9627C4.36169 10.6964 4.88633 10.497 5.38844 10.3691C5.91695 10.2344 6.45566 10.1741 6.98974 10.1595C7.5211 10.1451 8.04929 10.1762 8.57194 10.2327C8.75428 10.2523 8.93585 10.2759 9.11692 10.3018C10.0803 10.4401 11.0665 10.4028 12.0499 10.3538C12.5859 10.3269 13.1439 10.2937 13.6788 10.2843C14.2016 10.275 14.7017 10.3183 15.2124 10.4042C15.2957 10.4184 15.3786 10.4349 15.4605 10.4547C15.6366 10.4969 15.7975 10.5794 15.9722 10.6209C16.1841 10.6711 16.3825 10.6384 16.5999 10.5962C16.7618 10.5648 16.9788 10.5526 17.1146 10.4354C17.2099 10.3531 17.2587 10.2294 17.3144 10.1204C17.3891 9.9745 17.4778 9.83548 17.5414 9.68434C17.6277 9.47881 17.6504 9.28415 17.6773 9.06895C17.7184 8.73871 17.6918 8.44266 17.6337 8.12535ZM16.9672 8.50497L16.1612 7.94585C16.1039 7.90608 16.0714 7.83861 16.0742 7.7648L16.0748 7.74807C16.0836 7.51099 16.5128 7.56147 16.607 7.57554C16.6185 7.57716 16.6299 7.57856 16.6416 7.57952C16.7469 7.58858 17.3221 7.66081 17.3996 8.15306C17.4847 8.6953 16.9672 8.50497 16.9672 8.50497Z"
        fill="black"
      />
      <path
        d="M6.52318 9.20978C6.52318 9.20978 6.53048 9.2159 6.54379 9.22567C6.61288 9.27627 6.84451 9.4234 7.06021 9.30442L7.31219 9.22701C7.31219 9.22701 7.40343 9.27913 7.56021 9.36968C8.30612 9.80009 10.5322 11.0983 11.4308 11.7685C12.399 12.4906 13.7016 13.5849 14.2889 15.0791C14.3611 15.263 14.4226 15.4532 14.4713 15.6493C14.4713 15.6493 11.3565 15.1662 8.44875 13.4292C5.87084 11.8892 5.10013 11.4206 4.95863 11.3339C4.83353 11.2593 4.96047 11.0605 5.05376 10.9494C5.25487 10.7098 5.69088 10.1921 6.52318 9.20978Z"
        fill="black"
      />
    </svg>
  ),
  helpIcon: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="none"
      viewBox="0 0 16 16"
    >
      <g
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.4"
        clipPath="url(#clip0_2270_16589)"
      >
        <path d="M8 14.667A6.667 6.667 0 108 1.333a6.667 6.667 0 000 13.334z" />
        <path d="M6.06 6a2 2 0 013.886.667c0 1.333-2 2-2 2M8 11.333h.008" />
      </g>
      <defs>
        <clipPath id="clip0_2270_16589">
          <path fill="currentColor" d="M0 0H16V16H0z" />
        </clipPath>
      </defs>
    </svg>
  ),
  rotationIcon: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="70"
      height="70"
      fill="none"
      viewBox="0 0 70 70"
    >
      <path
        stroke="currentColor"
        strokeWidth="0.8"
        d="M69.6 34.819c0-1.282-.843-2.579-2.547-3.823-1.696-1.238-4.176-2.37-7.276-3.326-6.195-1.913-14.779-3.102-24.277-3.102-9.498 0-18.082 1.189-24.277 3.102-3.1.957-5.58 2.088-7.276 3.326C2.243 32.24 1.4 33.536 1.4 34.82c0 1.282.843 2.578 2.547 3.823 1.696 1.237 4.176 2.369 7.276 3.326 6.195 1.913 14.779 3.102 24.277 3.102 9.498 0 18.082-1.19 24.277-3.102 3.1-.957 5.58-2.089 7.276-3.326 1.704-1.245 2.547-2.541 2.547-3.823z"
      />
      <path
        stroke="currentColor"
        strokeWidth="0.8"
        d="M35 69.5c-18.819 0-34-15.593-34-34.412S16.256 1.013 35.074 1.013M35 69.5c19.33 0 34.5-15.67 34.5-35M67.222 21.852C66.99 15.37 53.896 1.013 35.077 1.013"
      />
      <path
        stroke="currentColor"
        d="M59.704 19.826l7.527 2.003 2.003-7.527M24.927 39.292l-5.507-5.508-5.507 5.508"
      />
      <path
        stroke="currentColor"
        strokeWidth="0.8"
        d="M37.326 1.013c9.82 0 17.78 15.256 17.78 34.075 0 18.818-7.96 34.074-17.78 34.074M19.547 25.352c1.016-11.196 7.96-24.339 17.78-24.339M19.543 34.356c0 23.386 7.96 34.806 17.78 34.806"
      />
    </svg>
  ),
  trashcan: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="16"
      fill="none"
      viewBox="0 0 14 16"
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M5 0a1 1 0 00-1 1v2H0v1h1v10a2 2 0 002 2h8a2 2 0 002-2V4h1V3h-4V1a1 1 0 00-1-1H5zm0 1v2h4V1H5zm4 3h3v10a1 1 0 01-1 1H3a1 1 0 01-1-1V4h7zM5 6.5a.5.5 0 00-1 0v6a.5.5 0 001 0v-6zM9.5 6a.5.5 0 01.5.5v6a.5.5 0 01-1 0v-6a.5.5 0 01.5-.5z"
        clipRule="evenodd"
      />
    </svg>
  ),
  downarrow: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="22"
      fill="none"
      viewBox="0 0 24 22"
    >
      <path
        stroke="currentColor"
        strokeLinecap="round"
        d="M12 4.223v12.635M17.455 12.97l-5.454 4.86-5.455-4.86"
      />
    </svg>
  ),
  directions: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="29"
      height="29"
      fill="none"
      viewBox="0 0 29 29"
      className="w-[17px] h-[17px] laptop:w-[29px] laptop:h-[29px]"
    >
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeWidth="0.893"
        d="M14.3 17.006v9.832M18.082 23.82l-3.781 3.775-3.782-3.788M14.299 11.595V1.762M10.518 4.781l3.781-3.775 3.781 3.788M11.594 14.3H1.762M4.781 18.082L1.006 14.3l3.788-3.78M17.006 14.3h9.832M23.818 10.519l3.775 3.781-3.788 3.782"
      />
    </svg>
  ),
  zoom: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="36"
      height="37"
      fill="none"
      viewBox="0 0 36 37"
      className="w-[20px] h-[20px] laptop:w-[36px] laptop:h-[36px]"
    >
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeWidth="0.893"
        d="M20.549 15.477l6.946-6.958M22.686 7.984h5.343v5.352M15.45 20.542L8.502 27.5M13.313 28.035H7.968v-5.352"
      />
    </svg>
  ),
  rotate: (
    <svg
      width="25"
      height="25"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 28.31 24.81"
    >
      <g id="Layer_1-2">
        <path className="stroke-current" d="M27.84,11l-3.26,3.32-3.32-3.26" />
        <path
          fill="none"
          className="stroke-current"
          d="M10.1,24.35C4.61,23.23,.47,18.36,.47,12.53,.47,5.87,5.87,.47,12.53,.47s12.06,5.4,12.06,12.06c0,.5-.04,1-.09,1.49"
        />
      </g>
    </svg>
  ),
  checkmark: (
    <svg
      width="11"
      height="12"
      viewBox="0 0 11 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M1 6.5L5 10.5L10 1" stroke="currentColor" />
    </svg>
  ),
  right_align: (
    <svg
      width="34"
      height="14"
      viewBox="0 0 34 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.9"
        d="M33 1L16 0.999999"
        stroke="currentColor"
        strokeLinecap="round"
      />
      <path
        opacity="0.9"
        d="M33 7L0.999998 7"
        stroke="currentColor"
        strokeLinecap="round"
      />
      <path
        opacity="0.9"
        d="M33 13L6 13"
        stroke="currentColor"
        strokeLinecap="round"
      />
    </svg>
  ),
  left_align: (
    <svg
      width="34"
      height="14"
      viewBox="0 0 34 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.9"
        d="M18 1L1 0.999999"
        stroke="currentColor"
        strokeLinecap="round"
      />
      <path
        opacity="0.9"
        d="M33 7L0.999998 7"
        stroke="currentColor"
        strokeLinecap="round"
      />
      <path
        opacity="0.9"
        d="M28 13L1 13"
        stroke="currentColor"
        strokeLinecap="round"
      />
    </svg>
  ),
  center_align: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="50"
      height="32"
      fill="none"
      viewBox="0 0 50 32"
    >
      <path
        stroke="currentColor"
        strokeLinecap="round"
        d="M4.455 16h14.181M14.273 10.545L19.727 16l-5.454 5.454M25 1v30M45.727 16H31.545M35.909 21.455L30.454 16l5.455-5.454"
      />
    </svg>
  ),
  image_left_align: (
    <svg
      width="26"
      height="18"
      viewBox="0 0 26 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M1 1V31" stroke="currentColor" strokeLinecap="round" />
      <path
        d="M21.7271 16L7.54523 16"
        stroke="currentColor"
        strokeLinecap="round"
      />
      <path
        d="M11.9089 21.4546L6.45439 16L11.9089 10.5455"
        stroke="currentColor"
        strokeLinecap="round"
      />
    </svg>
  ),
  image_center_align: (
    <svg
      width="50"
      height="50"
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.45459 25L18.6364 25"
        stroke="currentColor"
        strokeLinecap="round"
      />
      <path
        d="M14.2727 19.5454L19.7273 25L14.2727 30.4545"
        stroke="currentColor"
        strokeLinecap="round"
      />
      <path d="M25 10V40" stroke="currentColor" strokeLinecap="round" />
      <path
        d="M45.7271 25L31.5452 25"
        stroke="currentColor"
        strokeLinecap="round"
      />
      <path
        d="M35.9089 30.4546L30.4544 25L35.9089 19.5455"
        stroke="currentColor"
        strokeLinecap="round"
      />
    </svg>
  ),
  image_right_align: (
    <svg
      width="50"
      height="50"
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.5 2C0.5 1.17157 1.17157 0.5 2 0.5H48C48.8284 0.5 49.5 1.17157 49.5 2V48C49.5 48.8284 48.8284 49.5 48 49.5H2C1.17157 49.5 0.5 48.8284 0.5 48V2Z"
        stroke="white"
        strokeOpacity="0.04"
      />
      <path
        d="M16.4546 25L30.6364 25"
        stroke="currentColor"
        strokeLinecap="round"
      />
      <path
        d="M26.2727 19.5454L31.7273 25L26.2727 30.4545"
        stroke="currentColor"
        strokeLinecap="round"
      />
      <path d="M37 10V40" stroke="currentColor" strokeLinecap="round" />
    </svg>
  ),
  flip: (
    <svg
      width="24"
      height="26"
      viewBox="0 0 24 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <line
        x1="12.4418"
        y1="1.64591e-08"
        x2="12.4418"
        y2="26"
        stroke="currentColor"
        strokeWidth="0.89"
        strokeDasharray="4.78 4.78"
      />
      <path
        d="M22.9967 6.78262L17.0876 12.4348L22.9967 18.087V6.78262Z"
        stroke="currentColor"
        strokeWidth="0.89"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.00009 18.087L6.90918 12.4348L1.00009 6.78263L1.00009 18.087Z"
        stroke="currentColor"
        strokeWidth="0.89"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  loading: (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
      <circle
        opacity="0.25"
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"
        stroke-width="4"
      />
      <path
        opacity="0.75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
      />
    </svg>
  ),
};

const ThreekitIcons = ({ type, className }) => {
  const Icon = icons[type];

  return cloneElement(Icon, { className: clsx(Icon.className, className) });
};

export default ThreekitIcons;
